module.exports = __webpack_public_path__ + "media/images/log/log-graph-kanto-73f5512778ab3c7e488923d139cf06bf.svg";